import { Injectable, NgZone } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ScannerService {
    private scanSubject = new Subject<string>();

    public get onScan$(): Observable<string> {
        return this.scanSubject.asObservable();
    }

    constructor(private ngZone: NgZone) {
        (window as any).onScanReceived = (barcode: string) => {
            this.ngZone.run(() => {
                console.log(`🔫 ScannerService 接收到扫描数据: 原始 [${barcode}]`);
                this.scanSubject.next(barcode);
            });
        };
        console.log('✅ 全局扫描服务已初始化: window.onScanReceived');
    }
}
